<!--    //How to use external JS files and JavaScript code in Angular 6/7 https://www.truecodex.com/course/angular-6/how-to-use-external-js-files-and-javascript-code-in-angular
    // [25 HTML Funny 404 Pages](https://freefrontend.com/html-funny-404-pages/)
    // 404 Error Page Smoke From Toaster https://codepen.io/wikyware-net/pen/xywexE-->
<div class="ag-page-404">
  <div class="ag-toaster-wrap">
    <div class="ag-toaster">
      <div class="ag-toaster_back"></div>
      <div class="ag-toaster_front">
        <div class="js-toaster_lever ag-toaster_lever"></div>
      </div>
      <div class="ag-toaster_toast-handler">
        <div class="ag-toaster_shadow"></div>
        <div class="js-toaster_toast ag-toaster_toast js-ag-hide"></div>
      </div>
    </div>
    <canvas id="canvas-404" class="ag-canvas-404"></canvas>
    <img class="ag-canvas-404_img" src="assets/images/smoke.png">
  </div>
</div>
